import api from './client';
import type { PaginatedResponse, PaginationParams } from '../types/pagination';

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  role: string;
  preferred_locale: string;
  is_active: boolean;
  organization_id: string | null;
  last_login: string | null;
  created_at: string;
}

export async function getMyProfile() {
  const res = await api.get<UserProfile>('/users/me');
  return res.data;
}

export async function updateMyProfile(data: { full_name?: string; preferred_locale?: string }) {
  const res = await api.put<UserProfile>('/users/me', data);
  return res.data;
}

export async function changePassword(currentPassword: string, newPassword: string) {
  const res = await api.post<{ message: string }>('/users/me/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return res.data;
}

export async function resolveUserNames(userIds: string[]): Promise<Record<string, string>> {
  if (!userIds.length) return {};
  const res = await api.post<Record<string, string>>('/users/resolve-names', userIds);
  return res.data;
}

export async function listUsers(): Promise<UserProfile[]> {
  const res = await api.get<PaginatedResponse<UserProfile>>('/users');
  // Backward compat
  if (Array.isArray(res.data)) return res.data;
  return res.data.items;
}

export async function listUsersPaginated(params?: PaginationParams): Promise<PaginatedResponse<UserProfile>> {
  const res = await api.get<PaginatedResponse<UserProfile>>('/users', { params });
  return res.data;
}
